/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AdSpend
 */
export interface AdSpend {
  /**
   *
   * @type {string}
   * @memberof AdSpend
   */
  adSpendId?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof AdSpend
   */
  spendDate?: LocalDate;
  /**
   *
   * @type {number}
   * @memberof AdSpend
   */
  googleAdsSpendCad?: number;
  /**
   *
   * @type {number}
   * @memberof AdSpend
   */
  microsoftAdsSpendCad?: number;
}

/**
 * Check if a given object implements the AdSpend interface.
 */
export function instanceOfAdSpend(value: object): value is AdSpend {
  return true;
}

export function AdSpendFromJSON(json: any): AdSpend {
  return AdSpendFromJSONTyped(json, false);
}

export function AdSpendFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AdSpend {
  if (json == null) {
    return json;
  }
  return {
    adSpendId: json["adSpendId"] == null ? undefined : json["adSpendId"],
    spendDate: json["spendDate"] == null ? undefined : json["spendDate"],
    googleAdsSpendCad:
      json["googleAdsSpendCad"] == null ? undefined : json["googleAdsSpendCad"],
    microsoftAdsSpendCad:
      json["microsoftAdsSpendCad"] == null
        ? undefined
        : json["microsoftAdsSpendCad"],
  };
}

export function AdSpendToJSON(json: any): AdSpend {
  return AdSpendToJSONTyped(json, false);
}

export function AdSpendToJSONTyped(
  value?: AdSpend | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    adSpendId: value["adSpendId"],
    spendDate: value["spendDate"],
    googleAdsSpendCad: value["googleAdsSpendCad"],
    microsoftAdsSpendCad: value["microsoftAdsSpendCad"],
  };
}
